var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type == "link" && !_vm.url
    ? _c(
        "a",
        {
          staticClass: "t-link",
          attrs: { href: "#" },
          on: { click: _vm.onClick }
        },
        [
          _vm.hasSlot
            ? _vm._t("default")
            : [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
        ],
        2
      )
    : _vm.type == "link" && !_vm.externalUrl
    ? _c(
        "nuxt-link",
        {
          staticClass: "t-link",
          attrs: { to: _vm.url },
          nativeOn: {
            click: function($event) {
              return _vm.onClick($event)
            }
          }
        },
        [
          _vm.hasSlot
            ? _vm._t("default")
            : [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
        ],
        2
      )
    : _vm.type == "link" && _vm.externalUrl
    ? _c(
        "a",
        {
          staticClass: "t-link",
          attrs: { href: _vm.url },
          on: { click: _vm.onClick }
        },
        [
          _vm.hasSlot
            ? _vm._t("default")
            : [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
        ],
        2
      )
    : _vm.url && !_vm.externalUrl
    ? _c(
        "nuxt-link",
        {
          class: _vm.buttonClass,
          style: _vm.customColor
            ? { backgroundColor: _vm.customColor, border: "none" }
            : {},
          attrs: { to: _vm.url, disabled: _vm.isDisabled },
          nativeOn: {
            click: function($event) {
              return _vm.onClick($event)
            }
          }
        },
        [
          _vm.hasSlot
            ? _vm._t("default")
            : [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
        ],
        2
      )
    : _vm.url && _vm.externalUrl
    ? _c(
        "a",
        {
          class: _vm.buttonClass,
          style: _vm.customColor
            ? { backgroundColor: _vm.customColor, border: "none" }
            : {},
          attrs: { href: _vm.url, disabled: _vm.isDisabled },
          on: { click: _vm.onClick }
        },
        [
          _vm.hasSlot
            ? _vm._t("default")
            : [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
        ],
        2
      )
    : _vm.text || _vm.hasSlot
    ? _c(
        "button",
        {
          class: _vm.buttonClass,
          style: _vm.customColor
            ? { backgroundColor: _vm.customColor, border: "none" }
            : {},
          attrs: { disabled: _vm.isDisabled },
          on: { click: _vm.onClick }
        },
        [
          _vm.hasSlot
            ? _vm._t("default")
            : [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }